function categoryName(product) {
  return String(product?.category?.name || product?.category_name || "").trim();
}

function productSizes(product) {
  return Array.isArray(product?.sizes) ? product.sizes.map(String) : [];
}

function counted(items) {
  const counts = new Map();
  items.filter(Boolean).forEach((item) => counts.set(item, (counts.get(item) || 0) + 1));
  return [...counts].map(([name, count]) => ({ name, count })).sort((a, b) => a.name.localeCompare(b.name));
}

export function buildOccasionFacets(products) {
  const prices = products.map((product) => Number(product.min_price_paise) / 100).filter(Number.isFinite);
  return {
    categories: counted(products.map(categoryName)),
    colors: counted(products.map((product) => String(product.color || "").trim())),
    sizes: counted(products.flatMap(productSizes)),
    minPrice: prices.length ? Math.min(...prices) : 0,
    maxPrice: prices.length ? Math.max(...prices) : 0,
  };
}

export function filterOccasionProducts(products, filters) {
  return products.filter((product) => {
    const price = Number(product.min_price_paise) / 100;
    return (!filters.category || categoryName(product) === filters.category)
      && (!filters.color || product.color === filters.color)
      && (!filters.size || productSizes(product).includes(filters.size))
      && (filters.maxPrice == null || !Number.isFinite(price) || price <= filters.maxPrice);
  });
}
